export interface CharitableCampaign {
    campaignId: string;
    campaignName: string;
    charityName: string;
    charityDescription: string;
    charityDescriptionShort: string;
    countryCode: string;
    donationType: string;
    fixedAmount: 0;
    images: [
        {
            imageCategory: string;
            imageUrl: string;
        }
    ];
    learnMoreURL: string;
}

export interface CreateDonationApiRequest {
    charitableCampaignId: string;
    countryCode: string;
}

export enum DonationType {
    Fixed = 'Fixed',
    RoundUp = 'RoundUp',
}
